import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PageMeta } from './PageMeta'
import { WebUserSessionDto } from './WebUserSessionDto'
/**
* Class PageOfWebUserSessionDto
*  Результат постраничного запроса
*/
export class PageOfWebUserSessionDto extends ActiveModel {

  /**
  * meta
  * Meta-информация о результате постраничного запроса  */
  @ActiveField({
    factory: [PageMeta, () => undefined]
  })
  meta?: PageMeta


/**
  * @property items
  * Список элементов страницы<br>  */
  @ActiveField({
    factory: [WebUserSessionDto, () => undefined]
  })
  items?: Array<WebUserSessionDto>
}
